import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
    fetchViajeros,
    addViajero,
    updateViajero,
    deleteViajero,
    bulkImportTravelers,
} from "../../api/administration/serviceOrderApi";

export const useViajeros = (serviceOrderId, options = {}) => {
    const queryClient = useQueryClient();

    const { enabled = true } = options;

    const queryEnabled = Boolean(serviceOrderId) && Boolean(enabled);

    const {
        data: viajeros = [],
        error,
        isLoading,
        //isFetching,
        refetch,
    } = useQuery({
        queryKey: ["viajeros", serviceOrderId],
        queryFn: () => fetchViajeros(serviceOrderId),
        enabled: queryEnabled,
        retry: false,
        staleTime: 0,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchOnMount: true,
    });

    const invalidateViajerosCache = () => {
        queryClient.invalidateQueries({
            queryKey: ["viajeros", serviceOrderId],
        });
    };

    const addMutation = useMutation({
        mutationFn: (data) => addViajero(serviceOrderId, data),
        onSuccess: invalidateViajerosCache,
    });

    const updateMutation = useMutation({
        mutationFn: ({ servicioDetalleId, data }) =>
            updateViajero(servicioDetalleId, data),
        onSuccess: invalidateViajerosCache,
    });

    const deleteMutation = useMutation({
        mutationFn: ({ servicioDetalleId, data }) =>
            deleteViajero(servicioDetalleId, data),
        onSuccess: invalidateViajerosCache,
    });

    const bulkImportMutation = useMutation({
        mutationFn: (payload) => bulkImportTravelers(serviceOrderId, payload),
        onSuccess: (data) => {
            invalidateViajerosCache();
            return data;
        },
    });

    return {
        viajeros: queryEnabled ? viajeros : [],
        error,
        isLoading,
        //isFetching,
        refetch,
        addMutation,
        updateMutation,
        deleteMutation,
        bulkImportMutation,
    };
};